<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div [ngClass]="{ wrap: wrapContent }">
  <div class="flex flex-row" *ngIf="payload.properties.text?.value">
    <div class="flex label-cell">
      <label class="flex">
        <span>
          <div style="display: inline" [innerHTML]="payload.properties.text?.value | tokenToDiv"></div>
          <span class="required" *ngIf="payload.properties.required.value">*</span>
        </span>
      </label>
    </div>
  </div>

  <div class="flex flex-row" *ngIf="payload.properties.content?.value">
    <div class="flex word-wrap">
      <label class="flex subtitle">
        <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
      </label>
    </div>
  </div>

  <div class="flex flex-row spacing field-columns" [style.--field-column-count]="payload.properties.columns.length">
    <div class="flex field-cell rel" *ngFor="let field of payload.properties.columns; let columnIndex = index">
      <div class="flex flex-row flex-nosize field-label" *ngIf="field.text?.value">
        <div class="flex label-cell">
          <label class="flex">
            <span class="field-label-content">
              <span [innerHTML]="field.text?.value | tokenToDiv"></span>
              <span class="required" *ngIf="!payload.properties.text?.value && payload.properties.required.value">
                *
              </span>
              <fb-scribe-suggestion-indicator [target]="field"></fb-scribe-suggestion-indicator>
              <fb-amendment-field-indicator [fieldKey]="'c' + columnIndex" />
            </span>
          </label>
        </div>
      </div>

      <div class="rel field-control">
        <ng-container *ngIf="isDesign">
          <ng-container *ngIf="field.value.value">
            <div
              class="contenteditable"
              contenteditable="true"
              [innerHTML]="field.value.value | tokenToDiv"
              [ngStyle]="{ 'min-height': 20 + field.rows.value * 14 + 'px' }"
            ></div>
          </ng-container>
          <ng-container *ngIf="!field.value.value">
            <div
              class="contenteditable"
              contenteditable="true"
              style="color: gray"
              [innerHTML]="field.placeholder.value | tokenToDiv"
              [ngStyle]="{ 'min-height': 20 + field.rows.value * 14 + 'px' }"
            ></div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!isDesign">
          <div class="rel">
            <div
              class="contenteditable"
              tabindex="0"
              [(ngModel)]="field.value.value"
              (input)="clearScribeSuggestionMarker(field)"
              contenteditable="true"
              [ngStyle]="{ 'min-height': 20 + field.rows.value * 14 + 'px' }"
            ></div>
            <div
              style="color: gray"
              class="contenteditable-placeholder"
              *ngIf="isPrinting || isPreview ? false : !field.value.value"
            >
              {{ field.placeholder.value }}
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="field.hint?.value" class="hint" [innerHTML]="field.hint?.value | tokenToDiv"></div>

      <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
        This field is required
      </div>
    </div>
  </div>
</div>
